/**
 * 获取url参数
 * @param  {string} name 参数名
 * @return {string} 参数值
 */
export default function getUrlParams(name) {
    if (!window.location?.search) {
        return null;
    }
    const url = window.location.search.split('#')[0];
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const res = url.substr(1).match(reg);
    if (res !== null) {
        return decodeURIComponent(res[2]);
    }
    return null;
}
